<template>
  <div class="survey-progress">
    <div class="survey-progress__track">
      <div class="survey-progress__bar"
        :style="{ width: `${progress}%`,}">
      </div>
    </div>
    <div class="survey-progress__description">
      <h5 class="survey-progress__title">Progress</h5>
      <span class="survey-progress__percent">{{ progress }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-progress {
  margin-bottom: 24px;

  &__track {
    background: $color--blue-light;
    border-radius: 4px;
    height: 16px;
    margin-bottom: 4px;
  }

  &__bar {
    background: $color--blue;
    border-radius: 4px;
    height: 16px;
    transition: all 0.4s ease;
    width: 0%;
  }

  &__description {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: 12px;
    font-weight: 600;
  }

  &__percent {
    font-size: 12px;
    font-weight: 600;
    color: $color--blue;
  }
}
</style>
